// extracted by mini-css-extract-plugin
export default {"image":"vZ-z","loaded":"wZ-z"};